import React, { MutableRefObject, ReactNode, useRef } from "react";

import { ScrollNavigationContext } from "./ScrollNavigationContext";

interface ScrollNavigationProviderProps {
    children: ReactNode;
}

export const ScrollNavigationProvider: React.FC<ScrollNavigationProviderProps> = ({
    children
}: ScrollNavigationProviderProps) => {
    const sectionsRef: MutableRefObject<Record<string, HTMLElement>> = useRef({});

    const registerSection = (id: string, el: HTMLElement) => {
        sectionsRef.current[id] = el;
    };

    const scrollTo = (id: string) => {
        const el = sectionsRef.current[id];

        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <ScrollNavigationContext.Provider value={{ registerSection, scrollTo }}>
            {children}
        </ScrollNavigationContext.Provider>
    );
};
